<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{dialog_baslik}}</v-toolbar-title>

            </v-toolbar>
          </v-flex>
          <v-card-text>
            <v-flex pa-1 xs12 sm12 md12>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-form ref="formbanka" v-model="validbanka" lazy-validation>
                      <v-layout wrap>

                        <v-flex xs12 sm12 md12>
                          <div v-show="codegorunum === true ">
                            <v-text-field :label="$t('Bank-Code')" :color="color" v-model="Banka.BankCode"
                              :rules="passwordRules">
                              >
                            </v-text-field>
                          </div>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-text-field :label="$t('Bank-Name')" :color="color" v-model="Banka.BankName"
                            :rules="[v => !!v || $t('Mandatory-Areas')]">
                          </v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-text-field :label="$t('Bank-Short-Code')" :color="color" v-model="Banka.BankShortName">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                                   <cariaracomp tabindex="1" v-bind:etiket="$t('Select-Current-Account')" v-bind:value="Banka.Account" v-bind:renk="color" :loading="loading" 
                                  v-model="Banka.Account"></cariaracomp>
                        </v-flex>

                      </v-layout>
                    </v-form>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
             <v-btn color="blue darken-1" flat @click="vazgec()">{{$t('Cancel')}}</v-btn>

            <div v-show="m === true">
              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Delete" color="info" slot="activator" @click="deletebanka()" flat>
                  <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down"> {{ $t('Delete') }} </span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Delete"> {{ $t('Delete') }} </span>
              </v-tooltip>

              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Update" color="info" slot="activator" @click="guncelle()" flat>
                  <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Update') }}</span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
              </v-tooltip>


            </div>
            <div v-show="k === true">
              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Save" color="info" slot="activator" @click="Kaydet()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t("save_button")}}</span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{$t("save_button")}}</span>
              </v-tooltip>


            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title>{{$t('Bank')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="$t('Search')" append-icon="search">
        </v-text-field>


        <v-tooltip bottom>
          <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="bankaekle()" flat> <span
              class="hidden-sm-and-down"> <span class="hidden-sm-and-down"> {{ $t('Add-v2', { value: $t('Bank')}) }} </span>
            </span>
            <v-icon right dark>add_box</v-icon>

          </v-btn>
          <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
          <span v-if="sayfayetki.Save"> {{ $t('Add-v2', { value: $t('Bank')}) }}</span>
        </v-tooltip>





      </v-toolbar>
    </v-layout>

    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>

      </v-card-title>
      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
        :search="search3">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr @click="Getir(props.item.BankaKod)" item>
            <td class="text-xs-left">{{ props.item.SirketKodu }}</td>
            <td class="text-xs-left">{{ props.item.BankaKod }}</td>
            <td class="text-xs-left">{{ props.item.BankaAdi }}</td>
            <td class="text-xs-left">{{ props.item.BankaKisaKod }}</td>
            <td class="text-xs-left">{{ props.item.Kod }}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          {{ $t('No-records-searched-for', { value: search3}) }} 
        </v-alert>
      </v-data-table>
    </v-card>

    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import cariaracomp from '@/components/app/customcomp/cariaracomp'
  export default {
    data() {
      return {
        validbanka: true,
        passwordRules: [
          v => !!v || this.$t('This-space-cannot-left-blank'),
          v => (v && v.length < 5) || this.$t('Maximum-4-characters')
        ],
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        headers: [{
            text: this.$t('Company-Code'),
            value: 'SirketKodu'
          },
          {
            text: this.$t('Bank-Code'),
            value: 'BankaKod'
          },
          {
            text: this.$t('Bank-Name'),
            value: 'BankaAdi'
          },
          {
            text: this.$t('Bank-Short-Code'),
            value: 'BankaKisaKod'
          },
          {
            text: this.$t('Currentcode_label'),
            value: 'Kod'
          }

        ],
        loading: false,
        color: 'orange darken-4',
        items: [],
        search3: '',
        search: null,
        select: [],
        selected: '',
        m: false,
        k: false,
        dialog: false,
        Banka: {
          CompanyCode: '',
          BankCode: '',
          BankName: '',
          BankShortName: '',
          Account: ''
        },
        cari: '',
        state: [],
        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        bankakod: '',
        bankaadi: '',
        progress: false,
        dictionary: {
          custom: {
            bankakod: {
              required: () => this.$t('This-space-cannot-left-blank'),
              max: () => this.$t('Must-least-4-digits'),
            },
            bankaadi: {
              required: () => this.$t('This-space-cannot-left-blank'),
            }
          }
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    watch: {
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)



      if (this.sayfayetki.Status == true) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params = {
          CompanyCode: credentials.SirketKodu
        }
        this.progress = true
        this.$http.post(auth.API_URL + 'api/Bank/List', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body
          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.progress = false
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute
              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }
    },
    methods: {
      Getir(v) {
        this.k = false
        this.m = true
        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = this.$t('Edit-Bank')

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params = {
          CompanyCode: credentials.SirketKodu,
          BankCode: v
        }
        this.$http.post(auth.API_URL + 'api/Bank/Get', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.Banka.BankCode = response.body[0].BankaKod
          this.Banka.BankName = response.body[0].BankaAdi
          this.Banka.BankShortName = response.body[0].BankaKisaKod

          var params2 = response.body[0].Kod

          this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
            params2
          }, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.state = response.body
          })
          this.Banka.Account = response.body[0].Kod
          this.search = response.body[0].Kod
          this.Banka.Account =  response.body[0].Kod


        })
      },
      deletebanka: deletebanka,
      bankaekle: bankaekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
      vazgec: vazgec
    },
    beforeMount: beforeMount,
    components: {
      yetkidialog,
      cariaracomp
    },
    vazgec: vazgec
  }


  function vazgec() {
    this.dialog = false
    this.search = ''
    this.Banka.Account = ''
    this.bankaadi = ''
    this.bankakod = ''
    this.Banka.BankCode = ''
    this.Banka.BankName = ''
  }


  function Kaydet() {


    if (this.$refs.formbanka.validate()) {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      var params1 = {
        CompanyCode: credentials.SirketKodu
      }
      this.Banka.CompanyCode = credentials.SirketKodu
      var params = this.Banka
      this.$http.post(auth.API_URL + 'api/Bank/Add', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
          this.$http.post(auth.API_URL + 'api/Bank/List', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.dialog = false
            this.text1 = this.$t('Update-completed')
            this.snackbar = true
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })

        }else{
            this.dialog = false
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true
        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })

    }
  }

  function bankaekle() {

    this.dialog = true
    this.Banka = {}
    this.dialog_baslik = this.$t('Add-Bank')
    this.m = false
    this.k = true
    this.bankaadi = ''
    this.bankakod = ''
    this.Banka.BankCode = ''
    this.Banka.BankName = ''
    this.codegorunum = true
    this.$validator.reset()

  }

  function beforeMount() {

  }

  function deletebanka() {
    if (window.confirm('Bankay\'ı silmek istediğinizden eminmisiniz?')) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      var params1 = {
        CompanyCode: credentials.SirketKodu
      }
      this.Banka.CompanyCode = credentials.SirketKodu
      var params = this.Banka
      this.$http.post(auth.API_URL + 'api/Bank/Delete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true
          this.$http.post(auth.API_URL + 'api/Bank/List', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.search = response.body.Tarih
            this.dialog = false


          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })
        }
      }, (response) => {
        if (response.status === 0) {
          this.progress = false
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.progress = false
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })
    }
  }

  function guncelle() {
    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params1 = {
          CompanyCode: credentials.SirketKodu
        }
        this.Banka.CompanyCode = credentials.SirketKodu
        var params = this.Banka
        this.codegorunum = false
        this.$http.post(auth.API_URL + 'api/Bank/Update', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.text1 = this.$t('Update-completed')
            this.snackbar = true
            this.$http.post(auth.API_URL + 'api/Bank/List', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = response.statusText
                this.snackbar = true
              }
            })
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>

</style>